import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { GetInfosFromAvisImpot } from "components/app/Api/Remuneration/ApiRemuneration";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import Dialogs from "components/ui/dialogs/dialogs";
import Modal from "components/ui/modal/modal";
import { applyFormat } from "components/ui/ui-helpers";
import "components/app/AuditComplet/ContexteFiscal/ContexteFiscal.css";
import ContexteFiscalPageModal from "pages/audit complet/contexte fiscal/contexte fiscal pager";
import RemExpressContratFacPersoModal from "pages/audit rémunération/contrat facultatif perso";
import React, { useContext, useEffect, useRef, useState } from "react";
import { FaChartLine, FaHome, FaReceipt, FaUserTie, FaGlobe, FaFileInvoiceDollar } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import CompactFinancialCard, { CompactFinancialContainer, FINANCIAL_THEMES } from "./CompactFinancialCard";
import Row from "components/ui/layout/row/row";
import Column from "components/ui/layout/column/column";
import InfoMessage from "components/ui/controls/info-message";
import { AuthContext } from "components/auth/auth-provider";

function RemExpressRevenus(props) {
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const authContext = useContext(AuthContext);
  const hasPackExpert = authContext?.utilisateur_reel?.AccesMakoFormation === true || context.state.Partner === "EXCELIANCES"; // Accès au pack expert si l'utilisateur a le droit ou si le partenaire est EXCELIANCES
  const [modalPackExpert, setModalPackExpert] = useState(false);
  const [modalContexteFiscalOpen, setmodalContexteFiscalOpen] = useState(false);
  const [modalContratFacPerso, setmodalContratFacPerso] = useState(false);
  const [isUploadingIR, setIsUploadingIR] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [avisImpotData, setAvisImpotData] = useState(null);
  useEffect(() => {
    if (!isUploadingIR) {
      setUploadProgress(0);
      return;
    }
    setUploadProgress(0);
    // Simulated progress: fast at first, then slows near 90%
    const intervals = [
      { target: 30, delay: 80 },
      { target: 55, delay: 150 },
      { target: 70, delay: 250 },
      { target: 80, delay: 400 },
      { target: 88, delay: 700 },
      { target: 93, delay: 1200 },
    ];
    let current = 0;
    let timeouts = [];
    let elapsed = 0;
    intervals.forEach(({ target, delay }) => {
      const steps = target - current;
      for (let i = 1; i <= steps; i++) {
        const val = current + i;
        elapsed += delay;
        timeouts.push(setTimeout(() => setUploadProgress(val), elapsed));
      }
      current = target;
    });
    return () => timeouts.forEach(clearTimeout);
  }, [isUploadingIR]);
  const [modalAvisImpotOpen, setModalAvisImpotOpen] = useState(false);
  const declarationIrInputRef = useRef(null);

  const handleDeclarationIrUploadClick = () => {
    if (!hasPackExpert) {
      setModalPackExpert(true);
      return;
    }
    declarationIrInputRef.current?.click();
  };

  const handleDeclarationIrFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }

    try {
      setIsUploadingIR(true);
      const response = await GetInfosFromAvisImpot(file, context.state);

      const getTraitement = (declarant) => {
        if (!declarant) return 0;
        if (context.state.Statut === "TNS Article 62") return declarant.salaires || 0;
        if (context.state.Statut === "Assimilé salarié") return declarant.revenus_associes_gerants || 0;
        return declarant.salaires || 0;
      };

      setAvisImpotData({
        annee: response.annee_impot || "",
        creditImpot: Math.abs(response.credit_impot || 0),
        deductionFiscale: response.deductions_fiscales?.total || 0,
        declarant1: {
          nom: response.declarant_1?.nom || "Déclarant 1",
          traitement: getTraitement(response.declarant_1),
          autresRevenus: response.declarant_1?.autres_revenus_imposables || 0,
          revenus_pro_type: response.declarant_1?.revenus_pro_type || null,
          revenus_pro_regime_special_declares: response.declarant_1?.revenus_pro_regime_special_declares || 0,
          revenus_pro_abattement: response.declarant_1?.revenus_pro_abattement || 0,
          revenus_pro_regime_special_nets: response.declarant_1?.revenus_pro_regime_special_nets || 0,
          plafonds_non_utilises: response.declarant_1?.plafonds_non_utilises || [],
        },
        declarant2: {
          nom: response.declarant_2?.nom || "Déclarant 2",
          traitement: (response.declarant_2?.salaires || 0) + (response.declarant_2?.revenus_associes_gerants || 0),
          autresRevenus: response.declarant_2?.autres_revenus_imposables || 0,
          revenus_pro_type: response.declarant_2?.revenus_pro_type || null,
          revenus_pro_regime_special_declares: response.declarant_2?.revenus_pro_regime_special_declares || 0,
          revenus_pro_abattement: response.declarant_2?.revenus_pro_abattement || 0,
          revenus_pro_regime_special_nets: response.declarant_2?.revenus_pro_regime_special_nets || 0,
          plafonds_non_utilises: response.declarant_2?.plafonds_non_utilises || [],
        },
      });
      setModalAvisImpotOpen(true);
    } catch (error) {
      Dialogs.alert("Erreur lors de l'import de la déclaration IR.", "Erreur");
    } finally {
      setIsUploadingIR(false);
      event.target.value = "";
    }
  };

  const handleConfirmAvisImpot = () => {
    if (!avisImpotData) return;
    context.handleValueChange("ReductionImpot", Number(avisImpotData.creditImpot));
    context.handleValueChange("DeductionFiscale", Number(avisImpotData.deductionFiscale));
    context.handleValueChange("IRDirigeantTraitement", Number(avisImpotData.declarant1.traitement));
    context.handleValueChange("IRConjointTraitement", Number(avisImpotData.declarant2.traitement));
    context.handleValueChange("IRDirigeantAutresRevenus", Number(avisImpotData.declarant1.autresRevenus));
    context.handleValueChange("IRConjointAutresRevenus", Number(avisImpotData.declarant2.autresRevenus));

    // Traitement des revenus professionnels uniquement si le statut est différent de "TNS individuel"
    if (context.state.Statut !== "TNS individuel") {
      const processRevenusPro = (declarant, prefix) => {
        const declares = declarant.revenus_pro_regime_special_declares;
        const nets = declarant.revenus_pro_regime_special_nets;
        const type = declarant.revenus_pro_type;

        if (declares && nets && declares > 0) {
          const ratio = Math.round((nets / declares) * 100) / 100;
          let fieldName = null;

          // Détermination du champ selon le ratio
          if (Math.abs(ratio - 0.66) < 0.02) {
            fieldName = `${prefix}BNCMicro`;
          } else if (Math.abs(ratio - 0.29) < 0.02) {
            fieldName = `${prefix}BICMicroAchatRevente`;
          } else if (Math.abs(ratio - 0.5) < 0.02) {
            fieldName = `${prefix}BICMicroService`;
          } else if (Math.abs(ratio - 0.13) < 0.02) {
            fieldName = `${prefix}BAMicro`;
          } else {
            // Sinon on regarde le type
            if (type === "BNC") {
              fieldName = `${prefix}BNCControlle`;
            } else if (type === "BIC") {
              fieldName = `${prefix}BICReel`;
            } else if (type === "BA") {
              fieldName = `${prefix}BAReel`;
            }
          }

          if (fieldName) {
            context.handleValueChange(fieldName, Number(nets));
          }
        }
      };

      processRevenusPro(avisImpotData.declarant1, "IRDirigeant");
      processRevenusPro(avisImpotData.declarant2, "IRConjoint");
    }

    // Plafonds PER non utilisés - déclarant 1
    // Plafonds PER non utilisés - déclarant 1
    // Triés par année décroissante : index 0=N-1→Plafond3, 1=N-2→Plafond2, 2=N-3→Plafond1
    const fieldsDirigeant = ["IRDirigeantPlafond3", "IRDirigeantPlafond2", "IRDirigeantPlafond1"];
    const sortedPlafonds1 = [...(avisImpotData.declarant1.plafonds_non_utilises || [])].sort((a, b) => b.annee - a.annee);
    sortedPlafonds1.forEach((p, i) => {
      if (i < fieldsDirigeant.length) {
        context.handleValueChange(fieldsDirigeant[i], Number(p.montant));
      }
    });
    // Plafonds PER non utilisés - déclarant 2
    const fieldsConjoint = ["IRConjointPlafond3", "IRConjointPlafond2", "IRConjointPlafond1"];
    const sortedPlafonds2 = [...(avisImpotData.declarant2.plafonds_non_utilises || [])].sort((a, b) => b.annee - a.annee);
    sortedPlafonds2.forEach((p, i) => {
      if (i < fieldsConjoint.length) {
        context.handleValueChange(fieldsConjoint[i], Number(p.montant));
      }
    });
    setModalAvisImpotOpen(false);
    setTimeout(() => {
      context.handleCalculRemExpress(context.state.RemExpressTypeCalcul, "", ResultatTNS, "");
    }, 50);
  };

  return (
    <>
      <CompactFinancialContainer title="Analyse des revenus" subtitle="Détail des revenus et charges fiscales">
        <CompactFinancialCard
          icon={<FaChartLine />}
          title="Revenus d'activités perçus"
          value={applyFormat(context.state.RemExpressRevPercus, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          theme={FINANCIAL_THEMES.primary}
        />
        <CompactFinancialCard
          icon={<FaHome />}
          title="Autres revenus du foyer"
          value={applyFormat(context.state.RemExpressRevenusFoyer, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          theme={FINANCIAL_THEMES.primary}
        />
        <CompactFinancialCard
          icon={<FaReceipt />}
          title="Impôt sur le revenu"
          value={applyFormat(context.state.RemExpressIRTotal, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          onUpload={handleDeclarationIrUploadClick}
          uploadDisabled={isUploadingIR}
          onEdit={() => setmodalContexteFiscalOpen(true)}
          theme={FINANCIAL_THEMES.danger}
        />
        <CompactFinancialCard
          icon={<FaUserTie />}
          title="Cotisations facultatives personnelles"
          value={applyFormat(Number(context.state.RemExpressCotFacPerso), "uint", { thousands: " ", decimal: ",", unit: " €" })}
          onEdit={() => setmodalContratFacPerso(true)}
          idOnEdit={"contratFacPersoAuditRem"}
          theme={FINANCIAL_THEMES.orange}
        />
      </CompactFinancialContainer>
      {isUploadingIR && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(15,10,30,0.45)",
            zIndex: 1000000,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              background: "linear-gradient(145deg, #ffffff, #f5f3ff)",
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(139,92,246,0.25), 0 2px 8px rgba(0,0,0,0.12)",
              padding: "36px 40px",
              gap: "20px",
              minWidth: "340px",
              border: "1px solid rgba(139,92,246,0.15)",
            }}
          >
            {/* Icône animée */}
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #8b5cf6, #6d28d9)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 14px rgba(139,92,246,0.45)",
                animation: "pulse 1.8s ease-in-out infinite",
              }}
            >
              <FaFileInvoiceDollar style={{ color: "white", fontSize: "22px" }} />
            </div>
            {/* Titre */}
            <div style={{ textAlign: "center" }}>
              <p style={{ margin: 0, fontSize: "15px", fontWeight: 600, fontFamily: "Inter, sans-serif", color: "#1e1b4b" }}>Analyse de l'avis d'imposition</p>
              <p style={{ margin: "4px 0 0", fontSize: "12px", fontFamily: "Inter, sans-serif", color: "#6b7280" }}>Extraction des données fiscales en cours...</p>
            </div>
            {/* Barre de progression */}
            <div style={{ width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  height: "10px",
                  backgroundColor: "#ede9fe",
                  borderRadius: "999px",
                  overflow: "hidden",
                  boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                }}
              >
                <div
                  style={{
                    width: `${uploadProgress}%`,
                    height: "100%",
                    background: "linear-gradient(90deg, #a78bfa, #7c3aed)",
                    borderRadius: "999px",
                    transition: "width 0.3s ease-out",
                    boxShadow: "0 0 8px rgba(139,92,246,0.6)",
                  }}
                />
              </div>
              {/* Pourcentage */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "8px",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  color: "#7c3aed",
                  fontWeight: 600,
                }}
              >
                <span>Progression</span>
                <span>{uploadProgress} %</span>
              </div>
            </div>
            <style>{`
              @keyframes pulse {
                0%, 100% { transform: scale(1); box-shadow: 0 4px 14px rgba(139,92,246,0.45); }
                50% { transform: scale(1.08); box-shadow: 0 6px 20px rgba(139,92,246,0.65); }
              }
            `}</style>
          </div>
        </div>
      )}
      <input ref={declarationIrInputRef} type="file" style={{ display: "none" }} onChange={handleDeclarationIrFileChange} />
      <Modal
        width="80%"
        height="82%"
        title="Contexte fiscal"
        icon={<FaGlobe />}
        visible={modalContexteFiscalOpen}
        onClose={() => {
          context.handleCalculRemExpress(context.state.RemExpressTypeCalcul, "", ResultatTNS, "");
          setmodalContexteFiscalOpen(false);
        }}
      >
        <ContexteFiscalPageModal
          Outil=""
          visible={modalContexteFiscalOpen}
          onClose={() => {
            context.handleCalculRemExpress(context.state.RemExpressTypeCalcul, "", ResultatTNS, "");
            setmodalContexteFiscalOpen(false);
          }}
        />
      </Modal>
      <Modal
        width="80%"
        height="82%"
        title="Paramètres"
        icon={<FaGlobe />}
        visible={modalContratFacPerso}
        onClose={() => {
          context.handleCalculRemExpress(context.state.RemExpressTypeCalcul, "", ResultatTNS, "");
          setmodalContratFacPerso(false);
        }}
      >
        <RemExpressContratFacPersoModal
          ClientConjoint={""}
          Outil=""
          visible={modalContratFacPerso}
          onClose={() => {
            context.handleCalculRemExpress(context.state.RemExpressTypeCalcul, "", ResultatTNS, "");
            setmodalContratFacPerso(false);
          }}
        />
      </Modal>
      <Modal width="65%" height="72%" title={`Vérification des données importées`} icon={<FaFileInvoiceDollar />} visible={modalAvisImpotOpen} onClose={() => setModalAvisImpotOpen(false)}>
        {avisImpotData && (
          <Pager
            pages={[
              {
                content: (
                  <div className="revenuspro-container">
                    <Row bpad>
                      <InfoMessage
                        text={
                          context.state.Statut === "TNS individuel"
                            ? "Les revenus professionnels ne sont pas importés depuis l'avis d'imposition car ils sont déjà renseignés par l'utilisateur dans la case des revenus d'activités."
                            : "Les revenus professionnels seront automatiquement affectés aux champs appropriés selon le régime fiscal détecté (micro-entreprise ou régime réel)."
                        }
                      />
                    </Row>
                    {/* Header colonnes */}
                    <div className="header-card">
                      <div className="category-column" style={{ flex: 2 }}>
                        <span className="header-icon">📄</span>
                        Autres revenus du foyer
                      </div>
                      <div className="value-column">
                        <span className="header-icon">👤</span>
                        Client
                      </div>
                      <div className="value-column">
                        <span className="header-icon">👥</span>
                        Conjoint
                      </div>
                    </div>

                    {/* Traitements et salaires + Autres revenus */}
                    <div className="card-list-container">
                      <div className="card">
                        <div className="category-column" style={{ flex: 2 }}>
                          <div className="titre-icone">💰</div>
                          Traitements et salaires
                        </div>
                        <div className="value-column">
                          <TextField
                            value={avisImpotData.declarant1.traitement}
                            onChange={(e) => setAvisImpotData((prev) => ({ ...prev, declarant1: { ...prev.declarant1, traitement: e.target.value } }))}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            normal
                          />
                        </div>
                        <div className="value-column">
                          <TextField
                            value={avisImpotData.declarant2.traitement}
                            onChange={(e) => setAvisImpotData((prev) => ({ ...prev, declarant2: { ...prev.declarant2, traitement: e.target.value } }))}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            normal
                          />
                        </div>
                      </div>
                      <div className="card">
                        <div className="category-column" style={{ flex: 2 }}>
                          <div className="titre-icone">📊</div>
                          Autres revenus imposables
                        </div>
                        <div className="value-column">
                          <TextField
                            value={avisImpotData.declarant1.autresRevenus}
                            onChange={(e) => setAvisImpotData((prev) => ({ ...prev, declarant1: { ...prev.declarant1, autresRevenus: e.target.value } }))}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            normal
                          />
                        </div>
                        <div className="value-column">
                          <TextField
                            value={avisImpotData.declarant2.autresRevenus}
                            onChange={(e) => setAvisImpotData((prev) => ({ ...prev, declarant2: { ...prev.declarant2, autresRevenus: e.target.value } }))}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            normal
                          />
                        </div>
                      </div>
                      {context.state.Statut !== "TNS individuel" &&
                        (avisImpotData.declarant1.revenus_pro_regime_special_nets > 0 || avisImpotData.declarant2.revenus_pro_regime_special_nets > 0) && (() => {
                          // Déterminer le label pour chaque déclarant
                          const getLabel = (declarant) => {
                            const declares = declarant.revenus_pro_regime_special_declares;
                            const nets = declarant.revenus_pro_regime_special_nets;
                            const type = declarant.revenus_pro_type;
                            
                            if (declares && nets && declares > 0) {
                              const ratio = Math.round((nets / declares) * 100) / 100;
                              if (Math.abs(ratio - 0.66) < 0.02) {
                                return "BNC régime micro";
                              } else if (Math.abs(ratio - 0.29) < 0.02) {
                                return "BIC régime micro : activité d'achat revente, logement";
                              } else if (Math.abs(ratio - 0.5) < 0.02) {
                                return "BIC régime micro : activité de service";
                              } else if (Math.abs(ratio - 0.13) < 0.02) {
                                return "BA régime micro";
                              } else if (type === "BNC") {
                                return "BNC régime de la déclaration contrôlée";
                              } else if (type === "BIC") {
                                return "BIC régime réel simplifié ou normal";
                              } else if (type === "BA") {
                                return "BA régime réel simplifié ou normal";
                              }
                            }
                            return null;
                          };

                          const label1 = getLabel(avisImpotData.declarant1);
                          const label2 = getLabel(avisImpotData.declarant2);
                          const label = label1 || label2 || "Revenus professionnels";

                          return (
                            <div className="card">
                              <div className="category-column" style={{ flex: 2 }}>
                                <div className="titre-icone">💼</div>
                                {label}
                              </div>
                              <div className="value-column">
                                <TextField
                                  value={avisImpotData.declarant1.revenus_pro_regime_special_nets}
                                  onChange={(e) =>
                                    setAvisImpotData((prev) => ({
                                      ...prev,
                                      declarant1: { ...prev.declarant1, revenus_pro_regime_special_nets: e.target.value },
                                    }))
                                  }
                                  dataType="uint"
                                  format={{ thousands: " ", unit: " €" }}
                                  normal
                                />
                              </div>
                              <div className="value-column">
                                <TextField
                                  value={avisImpotData.declarant2.revenus_pro_regime_special_nets}
                                  onChange={(e) =>
                                    setAvisImpotData((prev) => ({
                                      ...prev,
                                      declarant2: { ...prev.declarant2, revenus_pro_regime_special_nets: e.target.value },
                                    }))
                                  }
                                  dataType="uint"
                                  format={{ thousands: " ", unit: " €" }}
                                  normal
                                />
                              </div>
                            </div>
                          );
                        })()}
                    </div>

                    {/* Section plafonds PER non utilisés */}
                    {((avisImpotData.declarant1.plafonds_non_utilises?.length > 0) || (avisImpotData.declarant2.plafonds_non_utilises?.length > 0)) && (
                      <>
                        <div className="header-card" style={{ marginTop: "16px" }}>
                          <div className="category-column" style={{ flex: 2 }}>
                            <span className="header-icon">📅</span>
                            Plafonds PER non utilisés
                          </div>
                          <div className="value-column">
                            <span className="header-icon">👤</span>
                          Client
                          </div>
                          <div className="value-column">
                            <span className="header-icon">👥</span>
                            Conjoint
                          </div>
                        </div>
                        <div className="card-list-container">
                          {(() => {
                            const allYears = Array.from(new Set([
                              ...(avisImpotData.declarant1.plafonds_non_utilises || []).map(p => p.annee),
                              ...(avisImpotData.declarant2.plafonds_non_utilises || []).map(p => p.annee),
                            ])).sort((a, b) => b - a);
                            return allYears.map((annee) => {
                              const p1 = avisImpotData.declarant1.plafonds_non_utilises?.find(p => p.annee === annee);
                              const p2 = avisImpotData.declarant2.plafonds_non_utilises?.find(p => p.annee === annee);
                              return (
                                <div className="card" key={annee}>
                                  <div className="category-column" style={{ flex: 2 }}>
                                    <div className="titre-icone">📅</div>
                                    Plafond {annee}
                                  </div>
                                  <div className="value-column">
                                    <TextField
                                      value={p1?.montant ?? 0}
                                      onChange={(e) => setAvisImpotData((prev) => {
                                        const list = [...(prev.declarant1.plafonds_non_utilises || [])];
                                        const idx = list.findIndex(p => p.annee === annee);
                                        if (idx >= 0) list[idx] = { ...list[idx], montant: Number(e.target.value) };
                                        else list.push({ annee, montant: Number(e.target.value) });
                                        return { ...prev, declarant1: { ...prev.declarant1, plafonds_non_utilises: list } };
                                      })}
                                      dataType="uint"
                                      format={{ thousands: " ", unit: " €" }}
                                      normal
                                    />
                                  </div>
                                  <div className="value-column">
                                    <TextField
                                      value={p2?.montant ?? 0}
                                      onChange={(e) => setAvisImpotData((prev) => {
                                        const list = [...(prev.declarant2.plafonds_non_utilises || [])];
                                        const idx = list.findIndex(p => p.annee === annee);
                                        if (idx >= 0) list[idx] = { ...list[idx], montant: Number(e.target.value) };
                                        else list.push({ annee, montant: Number(e.target.value) });
                                        return { ...prev, declarant2: { ...prev.declarant2, plafonds_non_utilises: list } };
                                      })}
                                      dataType="uint"
                                      format={{ thousands: " ", unit: " €" }}
                                      normal
                                    />
                                  </div>
                                </div>
                              );
                            });
                          })()}
                        </div>
                      </>
                    )}

                    {/* Section données fiscales globales */}
                    <div className="header-card" style={{ marginTop: "16px", background: "linear-gradient(135deg, #8BB9FF 0%, #6DA3FF 100%)" }}>
                      <div className="category-column">
                        <span className="header-icon">💳</span>
                        Données fiscales
                      </div>
                    </div>

                    <div className="card-list-container">
                      <div className="card">
                        <div className="category-column" style={{ flex: 2 }}>
                          <div className="titre-icone">✅</div>
                          Crédit d'impôt
                        </div>
                        <div className="value-column" style={{ gridColumn: "span 2" }}>
                          <TextField
                            value={avisImpotData.creditImpot}
                            onChange={(e) => setAvisImpotData((prev) => ({ ...prev, creditImpot: e.target.value }))}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            normal
                          />
                        </div>
                        <div className="value-column" />
                      </div>
                      <div className="card">
                        <div className="category-column" style={{ flex: 2 }}>
                          <div className="titre-icone">📉</div>
                          Déductions fiscales
                        </div>
                        <div className="value-column" style={{ gridColumn: "span 2" }}>
                          <TextField
                            value={avisImpotData.deductionFiscale}
                            onChange={(e) => setAvisImpotData((prev) => ({ ...prev, deductionFiscale: e.target.value }))}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            normal
                          />
                        </div>
                        <div className="value-column" />
                      </div>
                    </div>
                  </div>
                ),
              },
            ]}
            page={0}
            navButtons={{
              cancel: { onClick: () => setModalAvisImpotOpen(false) },
              validate: { onClick: handleConfirmAvisImpot },
            }}
          />
        )}
      </Modal>
      <Modal
        width="80%"
        height="40%"
        title="Pack Expert"
        visible={modalPackExpert}
        onClose={() => setModalPackExpert(false)}
      >
        <Column fill>
          <Row fill>
            <Column fill center className="modal-content">
              <br />
              L'import de l'avis d'imposition est une fonctionnalité réservée aux détenteurs du <strong>Pack Expert</strong>
              <br />
              <br />
              Pour y souscrire, contactez-nous à l'adresse suivante : <a href="mailto:support@mako-remexpert.com"><strong>support@mako-remexpert.com</strong></a>
              <br />
              Nous revenons vers vous très rapidement !
              <br />
              <br />
              Le Pack Expert comprend également :
              <br />
              <br />- Un guide complet sur la protection sociale : 150 pages de fiches pédagogiques sur la retraite et la prévoyance du chef d'entreprise.
              <br />- Des newsletters sur l'environnement social et fiscal du chef d'entreprise.
              <br />- Une base de contrats de prévoyance TNS intégrée sur votre espace MAKO.
              <br />- Une calculette de points AGIRC ARRCO permettant de contrôler les points acquis.
              <br />- Deux outils d'aide à la détermination et la déclaration du plafond PER.
              <br />- Un outil d'aide à la vente du PER.
              <br />
              <br />
            </Column>
          </Row>
        </Column>
      </Modal>
    </>
  );
}
export default RemExpressRevenus;
